import { Component, OnInit } from '@angular/core';
import { ListaCTService } from './lista-ct.service';
import { fuseAnimations } from '@fuse/animations';
import * as backInter from 'app/auth/auth-data.model';
import { AuthService } from 'app/auth/auth.service';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
@Component({
  selector: 'app-lista-ct',
  templateUrl: './lista-ct.component.html',
  styleUrls: ['./lista-ct.component.scss'],
  animations : fuseAnimations
})
export class ListaCTComponent implements OnInit {

  centrosTrabajo: backInter.getInfoCentros;
  cargando = true;
  productoCertificar: backInter.prodNorma35;
  empresaPadre:any;
  constructor(
    private colaboradoresService: ColaboradoresEncuestadorService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private listaService: ListaCTService,
    public authService: AuthService,
    private translateSrv: TranslateService,
    private idiomasService: IdiomasServiceN35,
    private router: Router, public snackBar: MatSnackBar,
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.obtieneCertificarActual();
  }
  private getEnterpriseDetail(index,idEnterprise : string,nombreCT) {
    this.empresaPadre=this.centrosTrabajo.centros[index].user;
    //empresaPadre
    //this.productoCertificar.fechaNorma35;
    this.router.navigate(['/NOM35/reporte-ct/',this.productoCertificar.fechaNorma35,this.centrosTrabajo.centros[index].totalColaboradores,idEnterprise,nombreCT,this.empresaPadre.empresaPadre],);
  }
  cantColaboradores=0;
  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;

              // CARGA DE LISTA DE CENTROS DE TRABAJO
              this.listaService.getInfoCentros(this.productoCertificar.fechaNorma35).subscribe( (resu:backInter.getInfoCentros) => {
                this.centrosTrabajo = resu;
                console.log("CENTROS TRABAJO");
                console.log(resu);
                this.cargando = false;
                for(let k=0; k < this.centrosTrabajo.centros.length;k++){
                  this.getAllTask (this.productoCertificar.fechaNorma35,this.centrosTrabajo.centros[k].totalColaboradores,this.centrosTrabajo.centros[k].user.empresaId);
                }

              });
              //FIN CARGA LISTA DE CENTROS

              throw BreakException;
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }


  autologin(user:string, password:string){
    let texto = 'MODALES.MENSAJES.WIZARD.NOM35.CENTROS.AUTOLOGIN.INFO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        let datosAutoLog = {
          user,
          password,
          productoId: this.productoCertificar.idNorma35,
          tipoNom:localStorage.getItem('tipoNorma35'),
          companyID:localStorage.getItem('companyID'),
          productoID:localStorage.getItem('productoID'),
          fechaNorma:localStorage.getItem('FechaNorma'),
        };
        // console.log(datosAutoLog);
        this.authService.logout(datosAutoLog);
      }
    });
  }
  data:any;
  arrayTodoList: any;
  cantidadTareas: number = 0;
  tareasFinalizadas:number = 0;
  porcentaje: number = 0;
  porcentajeCT: any [] = [];
  private getAllTask (fecha,totalcolaboradores,idempresa){
    this.data = {
      fechaDocumentador: fecha
    }
    var fechaTask;
    this.idiomasService.geTodoListCT(this.data,idempresa).subscribe( (data : any)=>{
console.log("data",data);
console.log("totalcolaboradores",totalcolaboradores);

        this.arrayTodoList = data.secciones;
        this.tareasFinalizadas=0;
        this.cantidadTareas=0;
          if(totalcolaboradores>50){
            // El index 1 es encuesta de 16 a 50
            this.arrayTodoList.splice(1,1);
          }else{
            //El index 2 es el de más de 50
            this.arrayTodoList.splice(2,1);
          }
          for(var i=0; i < this.arrayTodoList.length; i++){
            this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
              for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
                this.cantidadTareas++;
                if(this.arrayTodoList[i].tareas[k].estatus != "" && this.arrayTodoList[i].tareas[k].estatus != "Elegir"){
                  this.tareasFinalizadas++;
                }
              }
          }

          this.porcentaje = (this.tareasFinalizadas * 100) / this.cantidadTareas;
          var num= this.porcentaje.toFixed(2);
          //console.log("num "+num);

          this.porcentajeCT.push(num);
    });
  }

  private getSeccion (nombreseccion,pos){
    let pathTmp:any;
    switch(nombreseccion) {
      case "5.2 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp ="Política de prevención de riesgos psicosociales";

        break;
      }
      case "5.3 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp = "Encuesta 16-50 colaboradores";

        break;
      }
      case "5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial":{
        pathTmp ="Encuesta más 50 colaboradores";

        break;
      }
      case "5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos":{
        pathTmp ="Medidas de prevención y control";

        break;
      }
      case "5.6 Practicar exámenes médicos y evaluaciones psicológicas":{
        pathTmp ="Canal de quejas y denuncias";

        break;
      }
      case "5.1 a) La prevención de los factores de riesgo psicosocial":{
        pathTmp ="Acciones y programas preventivos";

        break;
      }
      case "5.1 b) La prevención de la violencia laboral":{
        pathTmp ="Programa de intervención con evaluaciones y medidas de control";

        break;
      }
      case "5.1 c) La promoción de un entorno organizacional favorable":{
        pathTmp ="Encuesta acontecimientos traumáticos severos";

        break;
      }
      case "5.7 a) La política de prevención de riesgos psicosociales":{
        pathTmp="Exámenes médicos y evaluaciones psicológicas";

        break;
      }
      case "5.7 b) Las medidas adoptadas para combatir las prácticas opuestas":{
        pathTmp ="Difusión y promoción de información";

        break;
      }
      case "5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...":{
        pathTmp ="Registros";

        break;
      }

   }


  }

}
